import styled, { keyframes } from "styled-components";
import ImageOne from '../assets/images/bg-01.webp';
import ImageTwo from '../assets/images/bg-02.webp';
import ImageThree from '../assets/images/bg-03.webp';
import ImageFour from '../assets/images/bg-04.webp';

// UNAUTH CSS OPEN

const changeBackground = keyframes`
    0% {
        background-image: url(${ImageOne});
    }

    25% {
        background-image: url(${ImageTwo});
    }

    50% {
        background-image: url(${ImageThree});
    }

    75% {
        background-image: url(${ImageFour});
    }

    100% {
        background-image: url(${ImageOne});
    }
`;

export const UnAuthLayoutWrapper = styled.div`
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    animation: ${changeBackground} 10s infinite;
    transition: all ease-in-out 1s;
    overflow: auto;
`;

export const UnAuthLayoutMain = styled.div`
    width: 100%;
    min-height: 100%;
    background-color: rgb(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const UnAuthLayoutContainer = styled.div`
    width: 90%;
    max-width: 750px;
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    background-color: var(--theme-color-secondary);
    border-radius: 2rem;
    overflow: hidden;
    margin: 40px auto;

    @media (max-width: 767px) {
        max-width: 400px;
    }

    .left {
        grid-column: span 2 / span 2;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;

        @media (max-width: 767px) {
            display: none;
        }
    }

    .right {
        grid-column: span 3 / span 3;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 20px;
        padding: 40px;

        @media (max-width: 767px) {
            grid-column: span 5 / span 5;
        }

        @media (max-width: 600px) {
            padding: 20px;
        }

        .logo {
            width: 100%;
            max-width: 220px;
            height: auto;
        }

        .text-contain {
            text-align: center;

            p {
                font-size: 14px;
                margin: 0;
            }
        }

        form {
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 20px;

            .form-error {
                color: var(--color-error);
                font-size: 11px;
                margin: 2px 0 0 0;
            }
        }
    }
`;

// UNAUTH CSS CLOSE

// AUTH CSS OPEN

export const AuthLayoutWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
`;

export const AuthLayoutContainer = styled.div`
    flex: 1;
    display: flex;
    overflow: auto;
`;

export const AuthLayoutBody = styled.div`
    flex: 1;
    width: 100%;
    padding: 40px;
    overflow-y: auto;
    overflow-x: hidden;

    @media (max-width: 600px) {
        padding: 20px 10px;
    }
`;

export const AuthPageContainer = styled.div`
    min-height: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;

    ${props => props.$heightfull && `
        max-height: 100%;
    `}
`;

export const AuthPageHead = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 10px;

    h1 {
        font-weight: 400;
    }

    .left {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 10px;

        svg.page-icon {
            color: var(--theme-color-sixth);
            width: 24px;
            height: auto;
        }

    }

    .right {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: end;
        gap: 10px;
    }

    .mui-actions {
        button {
            font-size: 11px;
        }

        svg {
            width: 16px;
            height: auto;
        }
    }
`;

// AUTH CSS CLOSE

export const HorizontalLine = styled.div`
    width: 100%;
    height: 0;
    border-bottom: 1px solid var(--border-color);
`;

export const AnchorButton = styled.button`
    appearance: none;
    border: none;
    background: none;
    color: var(--theme-color-primary);
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 5px;
    cursor: pointer;

    &:disabled {
        cursor: not-allowed;
        color: var(--text-color-secondary);

        span {
            color: var(--text-color-secondary);
        }
    }

    span {
        color: var(--theme-color-primary);
    }

    svg {
        width: 16px;
        height: auto;
    }
`;

export const ReactTableWrappers = styled.div`
     padding: 4px;
`;

export const ReactTableWrapper = styled.div`
    flex: 1;
    overflow: auto;
    background-color: var(--theme-color-secondary);
    color: var(--text-color-primary);

    .rt-tbody {
        overflow: hidden;
    }
    
    .ReactTable {
        min-width: max-content;
        display: block;

        .rt-noData {
            width: calc(100vw - 120px - 80px - 12px);
            position: sticky !important;
            left: 0;
            top: 0;
            transform: unset;
            display: flex;
            align-items: center;
            justify-content: center;

            @media only screen and (max-width: 600px) {
                width: calc(100vw - 50px - 20px - 12px);
            }
        }

        .-loading .-loading-inner {
            width: calc(100vw - 120px - 80px - 12px);
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            position: sticky !important;
            left: 0;
            top: unset;
            transform: unset;

            @media only screen and (max-width: 600px) {
                width: calc(100vw - 50px - 20px - 12px);
            }
        }
    }

    .pagination-top {
        width: calc(100vw - 120px - 80px - 12px);
        position: sticky;
        left: 0;
        padding: 10px;

        @media only screen and (max-width: 600px) {
            width: calc(100vw - 50px - 20px - 12px);
        }
    }

    .rt-thead {
        box-shadow: none !important;
    }

    .rt-th {
        background-color: var(--theme-color-eighth);
        font-size: 14px;
        font-weight: 600;
        padding: 10px 5px !important;
        border: 0 !important;
        /* border-top: 1px solid rgba(0, 0, 0, 0.05); */
        margin: 2px 2px 0 0;

        &:last-child {
            margin-right: 0;
        }
    }

    /* .rt-th:first-child {
        text-align: left;
    } */

    .rt-th, .rt-td {
        overflow: unset;
    }

    .rt-td {
        overflow: unset;
        font-size: 13px;
        white-space: break-spaces;
        word-break: break-word;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    /* position: relative; */

    /* .pagination-top {
        position: sticky !important;
        top: 0;
    } */

    /* .rt-table {
        position: relative;
            
        .rt-thead {
            position: sticky !important;
            top: 0;
        }
    } */
`;

export const P2Clamp = styled.div`
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    word-break: break-word;
`;